import { render, staticRenderFns } from "./outbound.vue?vue&type=template&id=1f1b9f32&scoped=true&"
import script from "./outbound.vue?vue&type=script&lang=js&"
export * from "./outbound.vue?vue&type=script&lang=js&"
import style0 from "./outbound.vue?vue&type=style&index=0&id=1f1b9f32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1b9f32",
  null
  
)

component.options.__file = "outbound.vue"
export default component.exports